module.exports = __webpack_public_path__ + "static/media/arrow-top.3caee3b1.svg";